export default __webpack_public_path__ + "static/media/logo.29d66d15.svg";